import { render } from "./Ticker.vue?vue&type=template&id=34b23421"
import script from "./Ticker.vue?vue&type=script&lang=js"
export * from "./Ticker.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Ticker.vue?vue&type=style&index=0&id=34b23421&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__